module.exports = __webpack_public_path__ + "img/information.8c0b6800.svg";